// extracted by mini-css-extract-plugin
export var actions = "Nav-module--actions--db0c8";
export var active = "Nav-module--active--a3d85";
export var burger = "Nav-module--burger--6b2c5";
export var inner = "Nav-module--inner--5dce4";
export var light = "Nav-module--light--ed33d";
export var link = "Nav-module--link--37cae";
export var links = "Nav-module--links--d8d7f";
export var nav = "Nav-module--nav--bdac6";
export var panel = "Nav-module--panel--8b220";
export var panelActions = "Nav-module--panelActions--9d0cb";
export var panelInner = "Nav-module--panelInner--b883b";
export var panelLink = "Nav-module--panelLink--e6e96";
export var phone = "Nav-module--phone--6cb79";
export var scrolled = "Nav-module--scrolled--4745b";